import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';

import { Checkbox } from '@mui/material';
import { Dispatch } from 'redux';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { RemarkRequest as RemarkType } from '../../../../business/models/dto/rim/remark.request.dto';
import { connect } from 'react-redux';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import styles from './rim.module.css';
import { updateRemark, setCurrentTabAsDirty } from '../../../../store/details/rim/actions';
import { Role } from '../../../../store/shared/model';

interface PropsFromState {
  readonly remark: RemarkType;
  readonly locked: boolean;
}

interface PropsFromDispatch {
  readonly updateValues: typeof updateRemark;
  readonly setCurrentTabAsDirty: typeof setCurrentTabAsDirty;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class Remark extends React.Component<AllProps> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }

  handleRemarkChange(value: string): void {
    this.props.updateValues({ ...this.props.remark, remark: value });
    if (this.props.remark.remarkSelected) {
      this.props.updateValues({ ...this.props.remark, remark: value, remarkSelected: true });
    }
    this.props.setCurrentTabAsDirty();
  }

  render() {
    return (
      <div>
        <div className={styles.content}>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <div className={styles.checkbox}>
                <Checkbox
                  disabled={this.props.locked}
                  checked={this.props.remark.remarkSelected}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    this.props.updateValues({ ...this.props.remark, remarkSelected: event.target.checked });
                    this.props.setCurrentTabAsDirty();
                  }}
                  value='true' />
              </div>
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <textarea className={styles.input}
                rows={4}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.rim.remark.placeholder')}
                value={this.props.remark.remark}
                onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
                  this.handleRemarkChange(event.target.value);
                }} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ details: { detailsRim }, caseState: { selectedCase }, shared: { roles }}: ApplicationState): PropsFromState => ({
  remark: detailsRim.remark,
  locked: detailsRim.locked === '' ? false : detailsRim.locked || selectedCase.blocked || !roles.includes(Role.ExFiLoAd),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateValues: (remark: RemarkType) => dispatch(updateRemark(remark)),
  setCurrentTabAsDirty: () => dispatch(setCurrentTabAsDirty())
});

export default connect(mapStateToProps, mapDispatchToProps)(Remark);
